export function hasSummaryValuesPermission(permissionType) {
  try {
    const permissions = JSON.parse(localStorage.getItem("permissions") || "{}");
    const summaryValuesPermission =
      permissions?.vendas?.[permissionType]?.permissoesEspecificas
        ?.visualizarValoresResumo;

    if (typeof summaryValuesPermission === "boolean") {
      return summaryValuesPermission;
    }

    return ["adm", "corporate"].includes(
      localStorage.getItem("userLevel")
    );
  } catch (_) {
    return false;
  }
}
